import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { SubscriberService } from '../../core/services/subscriber.service';
import { SubscriptionContextService } from '../../core/services/subscription-context.service';
import { Location } from '@angular/common';

interface Subscriber {
  _id: string;
  refNo?: string;
  companyName: string;
}

@Component({
  selector: 'app-subscription-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule],
  template: `
    <div class="flex flex-row gap-2" *ngIf="showSelector">
      <!-- <label for="subscription" class="block text-sm font-medium text-gray-700 mb-2">
        Subscription Context
      </label> -->
      <p-select
        id="subscription"
        [options]="subscribers"
        [(ngModel)]="selectedSubscriberId"
        optionLabel="companyName"
        optionValue="_id"
        placeholder="Select a subscription"
        (onChange)="onSubscriptionChange()"
        styleClass="w-full"
        [showClear]="true"
        [filter]="true"
        filterPlaceholder="Search subscriptions"
      >
        <ng-template pTemplate="selectedItem" let-subscriber>
          <div class="flex items-center gap-2">
            <span class="font-medium text-gray-500" *ngIf="subscriber.refNo">[{{ subscriber.refNo }}]</span>
            <span class="font-medium">{{ subscriber.companyName }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-subscriber>
          <div class="flex items-center gap-2">
            <span class="text-gray-500" *ngIf="subscriber.refNo">[{{ subscriber.refNo }}]</span>
            <span>{{ subscriber.companyName }}</span>
          </div>
        </ng-template>
      </p-select>
      <p class="text-xs text-gray-500 mt-1 hidden md:block">
        Select a subscription to act within that context
      </p>
    </div>
  `,
  styles: [`
    // .subscription-selector {
    //   padding: 1rem;
    //   border: 1px solid #e5e7eb;
    //   border-radius: 0.5rem;
    //   background-color: #f9fafb;
    // }
  `]
})
export class SubscriptionSelectorComponent implements OnInit {
  @Input() showSelector = false;
  @Output() subscriptionChanged = new EventEmitter<string | null>();
  
  subscribers: Subscriber[] = [];
  selectedSubscriberId: string | null = null;

  constructor(
    private subscriberService: SubscriberService,
    private subscriptionContextService: SubscriptionContextService,
    private location: Location
  ) {}

  ngOnInit() {
    if (this.showSelector) {
      this.loadSubscribers();
      this.loadCurrentSelection();
    }
  }

  private loadCurrentSelection(): void {
    const currentSelection = this.subscriptionContextService.getSelectedSubscriber();
    if (currentSelection.subscriberId) {
      this.selectedSubscriberId = currentSelection.subscriberId;
    }
  }

  async loadSubscribers() {
    try {
      const response = await this.subscriberService.getAllSubscribersForSelector().toPromise();
      if (response?.subscribers) {
        this.subscribers = response.subscribers;
      }
    } catch (error) {
      console.error('Failed to load subscribers:', error);
    }
  }

  onSubscriptionChange() {
    this.subscriptionChanged.emit(this.selectedSubscriberId);
    window.location.reload();
  }

  getSelectedSubscriberName(): string {
    const subscriber = this.subscribers.find(s => s._id === this.selectedSubscriberId);
    if (subscriber) {
      return subscriber.refNo ? `[${subscriber.refNo}] ${subscriber.companyName}` : subscriber.companyName;
    }
    return 'All Subscriptions';
  }

  clearSelection() {
    this.selectedSubscriberId = null;
    this.subscriptionChanged.emit(null);
  }
}
